import React from "react";
import { Box, Typography } from "@mui/material";
import ShareCard from "../components/ShareCard";
import { buildShareCards } from "../utils/buildShareCards";

const MOCK_GAME_TITLE = "Movies of the 90s";
const MOCK_GAME_DATE = new Date("2026-05-14");

const MOCK_STANDINGS = [
  { id: "p1", rank: 1, name: "Sasha",  score: 4800, isMe: true },
  { id: "p2", rank: 2, name: "Marcus", score: 3600, isMe: false },
  { id: "p3", rank: 3, name: "Jamie",  score: 2400, isMe: false },
  { id: "p4", rank: 4, name: "Riley",  score: 1800, isMe: false },
];

const MOCK_HIGHLIGHTS = [
  { id: "s1", header: "Big Guesser",        winner: "Sasha" },
  { id: "s2", header: "Speed Demon",        winner: "Marcus" },
  { id: "s3", header: "Comeback Kid",       winner: "Jamie" },
  { id: "s4", header: "Wagered It All",     winner: "Riley" },
  { id: "s5", header: "Final Round MVP",    winner: "Sasha" },
];

const MOCKS = {
  superlative: {
    header: "Big Guesser",
    winner: "Sasha",
    subhead: "Most points earned from gut feelings",
    emoji: "🎯",
    winnerDetail: "+$1,200 on hunches",
  },
  rank: {
    rankLabel: "1st",
    playerName: "Sasha",
    score: 4800,
    correctCount: 12,
    standings: MOCK_STANDINGS,
  },
  recap: {
    highlights: MOCK_HIGHLIGHTS,
    winnerName: "Sasha",
    winnerScore: 4800,
  },
  stats: {
    playerName: "Sasha",
    score: 4800,
    correctCount: 12,
    submissionCount: 18,
    fastestText: "1.4s",
  },
};

const tieScenario = {
  player: { id: "p1", name: "Sasha", score: 4800 },
  players: [
    { id: "p1", name: "Sasha",  score: 4800 },
    { id: "p2", name: "Marcus", score: 4800 },
    { id: "p3", name: "Jamie",  score: 2400 },
    { id: "p4", name: "Riley",  score: 1800 },
  ],
  superlatives: [],
};

const finalPairScenario = {
  player: {
    id: "p1",
    name: "Sasha",
    score: 24200,
    shareStats: {
      finalCard: {
        category: "90S MOVIES",
        clueText: "This 1994 film won Best Picture and grossed over $678 million worldwide",
        answer: "Forrest Gump",
        wager: 12100,
      },
    },
  },
  players: [{ id: "p1", name: "Sasha", score: 24200 }],
  superlatives: [],
};

const Card = ({ variant, data, label }) => (
  <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 1.5 }}>
    {label && (
      <Typography sx={{ fontFamily: "Helvetica Inserat", letterSpacing: "0.18em", color: "#1a7a72", fontSize: "0.9rem", textTransform: "uppercase" }}>
        {label}
      </Typography>
    )}
    <ShareCard
      variant={variant}
      data={data}
      gameTitle={MOCK_GAME_TITLE}
      gameDate={MOCK_GAME_DATE}
    />
  </Box>
);

const SectionHeader = ({ children }) => (
  <Typography sx={{
    fontFamily: "Helvetica Inserat",
    color: "#ffe066",
    fontSize: "1.4rem",
    letterSpacing: "0.12em",
    textTransform: "uppercase",
    textAlign: "center",
    mt: 6,
    mb: 3,
  }}>
    {children}
  </Typography>
);

const ScenarioGrid = ({ cards }) => (
  <Box sx={{
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(432px, max-content))",
    gap: 4,
    justifyContent: "center",
  }}>
    {cards.map((c, i) => (
      <Card key={`${c.variant}-${i}`} variant={c.variant} data={c.data} />
    ))}
  </Box>
);

const ShareCardPreview = () => {
  const tieCards = buildShareCards(tieScenario);
  const finalPairCards = buildShareCards(finalPairScenario);

  return (
    <Box sx={{
      minHeight: "100vh",
      background: "linear-gradient(160deg, #1a1a1a 0%, #2d2d2d 100%)",
      padding: "48px 24px",
    }}>
      <Box sx={{ maxWidth: 1200, margin: "0 auto", textAlign: "center", mb: 5 }}>
        <Typography sx={{ fontFamily: "Helvetica Inserat", color: "#ffe066", fontSize: "2.4rem", letterSpacing: "0.04em", fontWeight: 900 }}>
          Share Card Mockups
        </Typography>
        <Typography sx={{ color: "rgba(255,255,255,0.7)", letterSpacing: "0.2em", textTransform: "uppercase", fontSize: "0.85rem", mt: 1 }}>
          4:5 Instagram-native · 432×540 preview · exports at 1080×1350
        </Typography>
      </Box>

      <Box sx={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(432px, max-content))",
        gap: 4,
        justifyContent: "center",
      }}>
        <Card variant="superlative" data={MOCKS.superlative} label="Superlative — “I'm the…”" />
        <Card variant="rank"        data={MOCKS.rank}        label="Rank — “I came in…”" />
        <Card variant="recap"       data={MOCKS.recap}       label="Recap — “The Highlights”" />
        <Card variant="stats"       data={MOCKS.stats}       label="Stats — “My night”" />
      </Box>

      <SectionHeader>Tied at 1st</SectionHeader>
      <ScenarioGrid cards={tieCards} />

      <SectionHeader>Final correct — clue + answer pair</SectionHeader>
      <ScenarioGrid cards={finalPairCards} />
    </Box>
  );
};

export default ShareCardPreview;
